module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '\n<!-- assets/scripts/templates/factfinder-suggest-category.lodash.tpl -->\n<div class="mdl_search__section mdl_search__section--results">\n    <div class="mdl_search__section-header">\n        <div class="mdl_search__section-title">' +
((__t = ( window.StringTranslation.get( 'CATEGORY_SUGGESTIONS_HEADING' ) )) == null ? '' : __t) +
'</div>\n    </div>\n    <div class="mdl_search__section-content">\n        ';
 suggestions.forEach( ( category ) => { ;
__p += '\n        <a href="' +
((__t = ( category.Deeplink )) == null ? '' : __t) +
'" class="mdl_search__suggestions-cat" data-suggest="' +
((__t = ( category.dataSuggest )) == null ? '' : __t) +
'">\n            <div class="mdl_search__suggestions-cat-title">\n                ' +
((__t = ( mark( category.name ) )) == null ? '' : __t) +
'\n                ';
 if ( category.hitCount ) { ;
__p += '\n                <span class="mdl_search__suggestions-itemcount">' +
((__t = ( getCount( category.hitCount ) )) == null ? '' : __t) +
'</span>\n                ';
 } ;
__p += '\n            </div>\n            <div class="mdl_search__suggestions-cat-path">\n                ' +
((__t = ( category.ancestors.join( ' / ' ) )) == null ? '' : __t) +
'\n            </div>\n        </a>\n        ';
 }) ;
__p += '\n    </div>\n</div>\n';

}
return __p
};
